"use strict";

import i18n from "@/plugins/i18n";

export const CopyToClipboardMixin = {
  data: function () {
    return {
      tooltipText: this.$t("$company.organization.copy_to_clipboard"),
      showTooltip: false,
    };
  },
  methods: {
    copyToClipboard: function (selector) {
      let component = this;
      component.tooltipText = i18n.t("$company.organization.copied_to_clipboard");

      var copyText = document.querySelector(selector);
      copyText.setAttribute("type", "text");
      copyText.select();

      try {
        document.execCommand("copy");
        setTimeout(() => {
          component.tooltipText = i18n.t("$company.organization.copy_to_clipboard");
          component.showTooltip = false;
        }, 1000);
      } catch (err) {
        alert("Oops, unable to copy");
      }

      /* unselect the range */
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
};
